export const languageLevels = [
    {
        label: "Beginner",
        value: "beginner",
    },
    {
        label: "Intermediate",
        value: "intermediate",
    },
    {
        label: "Fluent",
        value: "fluent",
    },
];
